import { serviceStructureBuilder } from "../utils/helper"
import {
  FieldDefinition,
  FieldDefinitionGetter,
  FieldUniqueIdentifier,
  GetServiceFieldPath,
  IRegistryGetter,
  resolvePath,
  ServiceName,
  SubmissionLayout,
} from "../utils/types"
import { defaultFieldRegistry } from "./mappings"

// --- Factory Function ---
/**
 * Creates a specific field definition getter bound to a registry.
 */
export function makeGetFieldDefinition(
  registryGetter: IRegistryGetter,
): FieldDefinitionGetter {
  return (fuid: FieldUniqueIdentifier): FieldDefinition | undefined => {
    return registryGetter.get(fuid)
  }
}

// --- Default Instance ---
/**
 * Default field getter instance configured with the defaultFieldRegistry.
 */
export const getField: FieldDefinitionGetter =
  makeGetFieldDefinition(defaultFieldRegistry)

// getFieldPath is a convenience function to get the path of a field by its FUID
export const getServiceFieldPath: GetServiceFieldPath =
  (serverName: ServiceName, layout?: SubmissionLayout) =>
  (fuid: FieldUniqueIdentifier): string => {
    const fieldDef = getField(fuid)
    if (fieldDef) {
      return (
        resolvePath(fieldDef.serviceRepresentations[serverName], layout) ??
        "<unknown>"
      )
    }
    return "<unknown>"
  }

// --- Exports ---
export default getServiceFieldPath // Export the default instance

// Also export the factory and registry for flexibility
export * as Fuid from "./fuid" // Re-export FUID constants for easier access
export { defaultFieldRegistry } from "./mappings"

export const buildServiceStructure =
  serviceStructureBuilder(defaultFieldRegistry)
